/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: crm.fga
 * Run: pnpm run gen:permissions -- crm
 */

import type { ModulePermissions } from './types';

export const crmPermissions = {
  module: 'crm',
  displayName: 'Crm',
  entities: [
    {
      name: 'account',
      displayName: 'Account',
      permissions: [
        { key: 'accountRead', action: 'Read', category: 'crud' },
        { key: 'accountCreate', action: 'Create', category: 'crud' },
        { key: 'accountUpdate', action: 'Update', category: 'crud' },
        { key: 'accountDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'accountAddress',
      displayName: 'Account Address',
      permissions: [
        { key: 'accountAddressRead', action: 'Read', category: 'crud' },
        { key: 'accountAddressCreate', action: 'Create', category: 'crud' },
        { key: 'accountAddressUpdate', action: 'Update', category: 'crud' },
        { key: 'accountAddressDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'accountIdentityDocument',
      displayName: 'Account Identity Document',
      permissions: [
        {
          key: 'accountIdentityDocumentRead',
          action: 'Read',
          category: 'crud',
        },
      ],
    },
    {
      name: 'accountIndividualDetails',
      displayName: 'Account Individual Details',
      permissions: [
        {
          key: 'accountIndividualDetailsRead',
          action: 'Read',
          category: 'crud',
        },
      ],
    },
    {
      name: 'contact',
      displayName: 'Contact',
      permissions: [
        { key: 'contactRead', action: 'Read', category: 'crud' },
        { key: 'contactCreate', action: 'Create', category: 'crud' },
        { key: 'contactUpdate', action: 'Update', category: 'crud' },
        { key: 'contactDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'customerInvitation',
      displayName: 'Customer Invitation',
      permissions: [
        { key: 'customerInvitationRead', action: 'Read', category: 'crud' },
        {
          key: 'customerInvitationCancel',
          action: 'Cancel',
          category: 'custom',
        },
      ],
    },
    {
      name: 'invite',
      displayName: 'Invite',
      permissions: [
        { key: 'inviteCustomer', action: 'Customer', category: 'custom' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Crm module
 */
export type CrmPermissionKey =
  | 'accountRead'
  | 'accountCreate'
  | 'accountUpdate'
  | 'accountDelete'
  | 'accountAddressRead'
  | 'accountAddressCreate'
  | 'accountAddressUpdate'
  | 'accountAddressDelete'
  | 'accountIdentityDocumentRead'
  | 'accountIndividualDetailsRead'
  | 'contactRead'
  | 'contactCreate'
  | 'contactUpdate'
  | 'contactDelete'
  | 'customerInvitationRead'
  | 'customerInvitationCancel'
  | 'inviteCustomer';
